import { Tournament, TournamentRecurringType, TournamentTemplate } from '@repo/database/src/types';

export interface TournamentRecurringScheduleDto {
  id: string;
  templateId: string;
  recurringType: TournamentRecurringType | null;
  recurringFrequency: number | null;
  createdAt: Date;
  updatedAt: Date;
  template?: TournamentTemplate;
  lastIteration?: Tournament | null;
  nextIteration?: Tournament | null;
}

export interface CreateRecurringScheduleDto {
  templateId: string;
  recurringType: TournamentRecurringType;
  recurringFrequency?: number;
}

export interface UpdateRecurringScheduleDto {
  recurringType?: TournamentRecurringType;
  recurringFrequency?: number;
}
